import { getSkins } from '@sorare/core/src/set';

export const useSetHasMultipleSkins = (setSlug: Nullable<string>) => {
  return !!getSkins(setSlug).length;
};
